import {jwtDecode} from 'jwt-decode';
import {createAxiosInstance} from './api';
import SweetAlert from 'sweetalert2';
import errorIcon from './assets/error-icon.svg';

export const getPositionFromPostcode = async (postcode) => {
  try {
    return (
      await createAxiosInstance().post(`/api/teachers/postcode`, { postcode })
    ).data;
  } catch (error) {
    return { ok: -1 };
  }
};
export const showErrorMessage = (message) => {
  SweetAlert.fire({
    icon: errorIcon,
    imageHeight: "100px",
    title: "Oops...",
    text: message,
    confirmButtonColor: "#712d94",
  });
};

export const setToken = (value) => {
  localStorage.setItem("mathsAuthToken", value);
};

export const getToken = () => {
  const token = localStorage.getItem("mathsAuthToken");
  if (!token) return null;
  try {
    const decoded = jwtDecode(token);
    if (decoded.exp < Date.now() / 1000) {
      removeToken();
      return null;
    } else return token;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const isAuthenticated = () => {
  const token = getToken();
  return !!token;
};

export const removeToken = () => {
  localStorage.removeItem("mathsAuthToken");
};

export const isProfileCompleted = (profileUser, hasSubjects = true) => {
  const {
    about,
    qualifications,
    title,
    online,
    faceToFace,
    gender,
    publish,
    avatar,
  } = profileUser;

  const isQualificationAdded = Object.keys(qualifications).some(
    (k) => qualifications[k] !== -1
  );
  const isPersonalDetailsAdded =
    title &&
      gender !== -1 &&
      // publish !== -1 &&
      about &&
      about !== "<p><br></p>" &&
      avatar;
  const isStatusAdded = !!(online || faceToFace);

  return isQualificationAdded &&
      isPersonalDetailsAdded &&
      isStatusAdded &&
      hasSubjects;
};

export const isProfileReadyForSubmission = (profileUser, subjectsCompleted = false, billingCompleted = false) => {
  const {
    about,
    qualifications,
    title,
    online,
    avatar,
    faceToFace,
    gender,
    publish,
    level,
  } = profileUser;

  const isQualificationAdded = Object.keys(qualifications).some(
    (k) => qualifications[k] !== -1
  );
  const isPersonalDetailsAdded =
    title &&
    gender !== -1 &&
    // publish !== -1 && // Removed since publish is optional
    about &&
    about !== "<p><br></p>" &&
    avatar
      ? true
      : false;
  const isStatusAdded = !!(online || faceToFace);

  const isProfileReady =
    subjectsCompleted &&
    isQualificationAdded &&
    isPersonalDetailsAdded &&
    isStatusAdded &&
    billingCompleted
      
  return isProfileReady;
};
